<template>
  <div class="project-page" v-if="!dataHidden">
    <div style="margin-bottom:20px;">
      <a-spin :spinning="combatLoading">
        <a-radio-group button-style="solid" @change="combatChange">
          <a-radio-button
            v-for="item in combatData"
            :key="item.combatId"
            :value="item.combatId"
            :style="{background: (item.combatId == curCombat) ? '#b80000' : '#a2a0a0', color: 'white', borderColor: (item.combatId == curCombat) ? '#b80000' : '#a2a0a0' }">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-spin>
    </div>
    <div v-if="showType === 13">
      <div style="overflow: hidden;margin-bottom:20px;" v-if="oneList.length > 0">
        <h2><img src="../../assets/jin.png" style="width:20px;">&ensp;金牌</h2>
        <div v-for="(item, index) in oneList" :key="index" style="overflow: hidden;width:80px;height:85px;float:left;text-align: center;margin: 5px;">
          <a-avatar :src="item.logo" :size="64"/>
          <p>{{ item.name }}{{ new Date().getFullYear() - Number(item.birthday.split('-')[0]) }}岁</p>
        </div>
      </div>
      <div style="overflow: hidden;margin-bottom:20px;" v-if="twoList.length > 0">
      <h2><img src="../../assets/yin.png" style="width:20px;">&ensp;银牌</h2>
      <div v-for="(item, index) in twoList" :key="index" style="overflow: hidden;width:80px;height:85px;float:left;text-align: center;margin: 5px;">
        <a-avatar :src="item.logo" :size="64"/>
        <p>{{ item.name }}{{ new Date().getFullYear() - Number(item.birthday.split('-')[0]) }}岁</p>
      </div>
      </div>
      <div style="overflow: hidden;margin-bottom:20px;" v-if="threeList.length > 0">
      <h2><img src="../../assets/tong.png" style="width:20px;">&ensp;铜牌</h2>
      <div v-for="(item, index) in threeList" :key="index" style="overflow: hidden;width:80px;height:85px;float:left;text-align: center;margin: 5px;">
        <a-avatar :src="item.logo" :size="64"/>
        <p>{{ item.name }}{{ new Date().getFullYear() - Number(item.birthday.split('-')[0]) }}岁</p>
      </div>
      </div>
      <div style="overflow: hidden;margin-bottom:20px;" v-if="fourList.length > 0">
      <h2>优胜奖</h2>
      <div v-for="(item, index) in fourList" :key="index" style="overflow: hidden;width:80px;height:85px;float:left;text-align: center;margin: 5px;">
        <a-avatar :src="item.logo" :size="64"/>
        <p>{{ item.name }}{{ new Date().getFullYear() - Number(item.birthday.split('-')[0]) }}岁</p>
      </div>
      </div>
      <div style="overflow: hidden;" v-if="fiveList.length > 0">
      <h2>鼓励奖</h2>
      <div v-for="(item, index) in fiveList" :key="index" style="overflow: hidden;width:80px;height:85px;float:left;text-align: center;margin: 5px;">
        <a-avatar :src="item.logo" :size="64"/>
        <p>{{ item.name }}{{ new Date().getFullYear() - Number(item.birthday.split('-')[0]) }}岁</p>
      </div>
      </div>
    </div>
    <div class="table-list" v-else>
      <div class="row table-header">
        <div class="col col-1 text-left">项目名称</div>
        <div class="col col-1 text-center"><img src="../../assets/jin.png"></div>
        <div class="col col-1 text-center"><img src="../../assets/yin.png"></div>
        <div class="col col-1 text-center"><img src="../../assets/tong.png"></div>
      </div>
      <a-spin :spinning="rankLoading">
        <template v-for="(item, index) in rankData">
          <div class="row" v-if="rankData.length > 0" :key="index">
            <div class="col col-1">
              {{ item.fullName }}
            </div>
            <div class="col col-1 text-center">
              <a-row style="width: 100%">
                <a-col :span="item.rank1.length == 0 ? 24 : (24/item.rank1.length)" v-for="(rank, index) in item.rank1" :key="'rank1_' + index">
                  <span v-if="rank.players != null && rank.players.length > 0">
                    <span v-if="rank.players.length <= 3">
                      {{ calTeamName(rank.players) }}<br/>
                      单位：{{ rank.name }}
                    </span>
                    <span v-else>
                      <a-popover title="第一名获奖者">
                        <template slot="content">
                          <div style="width: 300px; height: auto;">
                            <div style="width: 50px; height: 70px; margin: 10px;display: inline-block;" v-for="(player, index) in rank.players" :key="'rank1Player_' + index">
                              <p align="center"><a-avatar :src="player.head" size="large"/></p>
                              <p align="center">{{ player.name }}</p>
                            </div>
                          </div>
                        </template>
                        <a-avatar :src="rank.logo" :size="64"/>
                        <p>{{ rank.name }}</p>
                      </a-popover>
                    </span>
                  </span>
                  <span v-else>
                    <a-avatar :src="rank.logo" :size="64"/>
                    <p>{{ rank.name }}</p>
                  </span>
                </a-col>
              </a-row>
            </div>
            <div class="col col-1 text-center">
              <a-row style="width: 100%">
                <a-col :span="item.rank2.length == 0 ? 24 : (24/item.rank2.length)" v-for="(rank, index) in item.rank2" :key="'rank2_' + index">
                  <span v-if="rank.players != null && rank.players.length > 0">
                    <span v-if="rank.players.length <= 3">
                      {{ calTeamName(rank.players) }}<br/>
                      单位：{{ rank.name }}
                    </span>
                    <span v-else>
                      <a-popover title="第二名获奖者">
                        <template slot="content">
                          <div style="width: 300px; height: auto;">
                            <div style="width: 50px; height: 70px; margin: 10px;display: inline-block;" v-for="(player, index) in rank.players" :key="'rank2Player_' + index">
                              <p align="center"><a-avatar :src="player.head" size="large"/></p>
                              <p align="center">{{ player.name }}</p>
                            </div>
                          </div>
                        </template>
                        <a-avatar :src="rank.logo" :size="64"/>
                        <p>{{ rank.name }}</p>
                      </a-popover>
                    </span>
                  </span>
                  <span v-else>
                    <a-avatar :src="rank.logo" :size="64"/>
                    <p>{{ rank.name }}</p>
                  </span>
                </a-col>
              </a-row>
            </div>
            <div class="col col-1 text-center">
              <a-row style="width: 100%">
                <a-col :span="item.rank3.length == 0 ? 24 : (24/item.rank3.length)" v-for="(rank, index) in item.rank3" :key="'rank3_' + index">
                  <span v-if="rank.players != null && rank.players.length > 0">
                    <div v-if="rank.players.length <= 3" style="border:1px dashed #ccc;margin-right:5px;">
                      {{ calTeamName(rank.players) }}<br/>
                      单位：{{ rank.name }}
                    </div>
                    <span v-else>
                      <a-popover style="width: 300px;" title="第三名获奖者">
                        <template slot="content">
                          <div style="width: 300px; height: auto;">
                            <div style="width: 50px; height: 70px; margin: 10px;display: inline-block;" v-for="(player, index) in rank.players" :key="'rank3Player_' + index">
                              <p align="center"><a-avatar :src="player.head" size="large"/></p>
                              <p align="center">{{ player.name }}</p>
                            </div>
                          </div>
                        </template>
                        <a-avatar :src="rank.logo" :size="64"/>
                        <p>{{ rank.name }}</p>
                      </a-popover>
                    </span>
                  </span>
                  <span v-else>
                    <a-avatar :src="rank.logo" :size="64"/>
                    <p>{{ rank.name }}</p>
                  </span>
                </a-col>
              </a-row>
            </div>
          </div>
        </template>
      </a-spin>
    </div>
  </div>
  <div class="content" v-else>
    <a-empty
      :image="hiddenImg"
      :image-style="{height: '30px'}">
      <span slot="description" style="color:#bbbaba;">
        <!-- 主办方隐藏了获奖信息 -->
        </span>
    </a-empty>
  </div>
</template>

<script>
export default {
  name: 'project',
  mounted () {
    // 初始化
    this.queryAgencyMedalCombat()
  },
  data () {
    return {
      matchId: this.$route.query.matchId,
      programId: this.$route.query.programId,
      combatData: [],
      rankData: [],
      oneList: [],
      twoList: [],
      threeList: [],
      fourList: [],
      fiveList: [],
      curCombat: 1,
      showType: 1,
      combatLoading: false,
      rankLoading: false,
      defaultHead: require('../../assets/photo.png'),
      emptyImg: require('../../assets/empty.png'),
      dataHidden: false,
      hiddenImg: require('../../assets/hidden.png')
    }
  },
  methods: {
    queryAgencyMedalCombat () {
      this.combatLoading = true
      this.$api.match.queryAgencyMedalCombat({matchId: this.matchId}).then(res => {
        this.combatLoading = false
        if (res.status === 0) {
          this.combatData = res.data.combats
          if (this.combatData.length > 0) {
            this.curCombat = this.combatData[0].combatId
            this.showType = this.combatData[0].matchSystem
            this.queryMedalCombatRank()
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    queryMedalCombatRank () {
      this.oneList = []
      this.twoList = []
      this.threeList = []
      this.fourList = []
      this.fiveList = []
      this.rankLoading = true
      this.$api.match.queryMedalCombatRank({matchId: this.matchId, combatId: this.curCombat}).then(res => {
        this.rankLoading = false
        if (res.status === 0) {
          this.rankData = res.data
          if (this.showType === 13) {
            this.rankData.forEach(element => {
              this.oneList = [...this.oneList,  ...element.rank1]
              this.twoList = [...this.twoList,  ...element.rank2]
              this.threeList = [...this.threeList,  ...element.rank3]
              this.fourList = [...this.fourList,  ...element.rank4]
              this.fiveList = [...this.fiveList,  ...element.rank5]
            })
          }
          console.log(this.oneList)
          this.dataHidden = false
        } else if (res.status === 1102003) {
          this.dataHidden = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    combatChange (e) {
      this.curCombat = e.target.value
      let arr = this.combatData.filter((item) => {
        return item.combatId === this.curCombat
      })
      if (arr.length > 0) {
        this.showType = arr[0].matchSystem
      }
      this.queryMedalCombatRank()
    },
    calTeamName (playerList) {
      let str = ''
      playerList.forEach(element => {
        str += element.name + '/'
      })
      return str.substr(0, str.length - 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
  background-color: gray;
}
/deep/.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  color: white;
  padding: 7px 16px;
  padding-left: 40px;
}
.table-list {
 background-color:#fff
}
.table-list .table-header {
 color:#000;
 font-weight:700;
 background-color:#e5e5e5;
 border-bottom:1px solid #e8e8e8
}
.table-list .table-header .col {
 padding:16px 8px!important
}
.table-list .table-header img {
 max-width:20px
}
.table-list .col {
 display:-webkit-box;
 display:-ms-flexbox;
 display:flex;
 -webkit-box-align:center;
 -ms-flex-align:center;
 align-items:center;
 padding:8px
}
.table-list .col-1 {
 -webkit-box-flex:1;
 -ms-flex:1;
 flex:1
}
.table-list .col-2 {
 -webkit-box-flex:2;
 -ms-flex:2;
 flex:2
}
.table-list .col-3 {
 -webkit-box-flex:3;
 -ms-flex:3;
 flex:3
}
.table-list .col-4 {
 -webkit-box-flex:4;
 -ms-flex:4;
 flex:4
}
.table-list .col-5 {
 -webkit-box-flex:5;
 -ms-flex:5;
 flex:5
}
.table-list .col-6 {
 -webkit-box-flex:6;
 -ms-flex:6;
 flex:6
}
.table-list .text-center {
 -webkit-box-pack:center;
 -ms-flex-pack:center;
 justify-content:center;
 text-align:center
}
.table-list .row {
 display:-webkit-box;
 display:-ms-flexbox;
 display:flex;
 -webkit-box-orient:horizontal;
 -webkit-box-direction:normal;
 -ms-flex-direction:row;
 flex-direction:row;
 border-bottom:1px solid #e8e8e8;
 min-height:60px
}
.table-list .row .check-table {
 margin-right:5px
}
.table-list .row .table-logo {
 width:45px;
 height:45px;
 border-radius:50%;
 margin-right:5px;
 border:1px solid #f8f8f8;
 cursor:pointer
}
.table-list .row .btn-del,
.table-list .row .btn-jj,
.table-list .row .btn-tg {
 cursor:pointer;
 border:1px solid #e8e8e8;
 margin:0 5px;
 padding:0 5px;
 border-radius:2px
}
.table-list .row .btn-tg {
 color:#42ad00
}
.table-list .row .btn-tg:hover {
 color:#fff;
 border:1px solid #42ad00;
 background-color:#42ad00
}
.table-list .row .btn-jj {
 color:#f14f2b
}
.table-list .row .btn-jj:hover {
 color:#fff;
 border:1px solid #f14f2b;
 background-color:#f14f2b
}
.table-list .row .btn-del {
 color:#000
}
.table-list .row .btn-del:hover {
 color:#fff;
 border:1px solid #000;
 background-color:#000
}
.table-list .row-empty {
 color:rgba(0,0,0,.25);
 border:1px solid #e8e8e8;
 border-top:none;
 min-height:160px;
 display:-webkit-box;
 display:-ms-flexbox;
 display:flex;
 -webkit-box-align:center;
 -ms-flex-align:center;
 align-items:center;
 -webkit-box-pack:center;
 -ms-flex-pack:center;
 justify-content:center;
 -webkit-box-orient:vertical;
 -webkit-box-direction:normal;
 -ms-flex-direction:column;
 flex-direction:column;
 background-color:#fff
}
</style>



// WEBPACK FOOTER //
// src/comm/components/modal/project.vue